import React, {
  useContext,
  useEffect,
  useState
} from 'react';

import {
  getEnv,
  getUniqueSpeedsArray,
  isMobileView
} from 'src/Utility/utility';

import {
  SalesContext
} from 'src/Context/SalesContext';

import Curve from 'src/Components/Curve/Curve';

import WhyChooseVodacomFibre from 'src/Components/Common/WhyChooseVodacomFibre/WhyChooseVodacomFibre';

import {
  BlueRightArrow,
  PencilIcon,
  ChevronDownIcon,
  Checkbox,
  ChevronLeft,
  ArrowIcon,
} from 'src/Components/Common';

import GridBreadcrumbs from 'src/Components/GridBreadcrumbs/GridBreadcrumbs';

import {
  tagContractTermFilterClick,
  tagOnChooseFibrePlan,
  tagOnPrepaidCardClick,
  tagOnSwitchToBusinessClick,
  tagOnTopPickClick
} from 'src/Tagging/SalesTagging';

import {
  useSalesPackages
} from 'src/Hooks/useDealGrid';

import FilterDropDown from 'src/Components/Common/FilterDropDown/FilterDropDown';

import { PrepaidFibreUrls } from 'src/Common/constants';

import { useDeviceType } from 'src/Hooks/useDeviceType';

import SideDrawer from 'src/Components/Common/SideDrawer/SideDrawer';

import Card from './Components/Card/Card';

import Pill from './Components/Pill/Pill';

import NewHelpMeChoosePlan from './Components/HelpMeChoosePlan/NewHelpMeChoosePlan';

import TopPicks from './Components/TopPicks/TopPicks';

import NoDealsFound from './Components/NoDealsFound/NoDealsFound';

import './DealGrid.css';

const DealGrid = (props) => {

  const salesContext = useContext(SalesContext);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [hasSelectedContractLength, setHasSelectedContractLength] = useState(false);
  const [hasPromo, setHasPromo] = useState(false);
  const isMobile = useDeviceType()

  const {
    updateSortSelection,
    handleTermCheckboxChange,
    handlePromotionsCheckboxChange,
    handleSpeedCheckboxChange,
    getPlanDetails,
    orderBy,
    filterByDiscount,
    filterBySpeeds,
    checkPromotions,
    clearFilters,
    appProactiveSalesFlag,
    miniAppProactiveSalesFlag,
    contractTerms,
    sortOptions,
    hasRedirected
  } = useSalesPackages();

  const firstBatchCount = isMobileView() ? 4 : 6;
  const [firstBatch, setFirstBatch] = useState([]);
  const [secondBatch, setSecondBatch] = useState([]);
  const [topPicks, setTopPicks] = useState([]);

  useEffect(() => {
    const packages = salesContext.providerPackages || [];

    setTopPicks(salesContext.topPicks);
    setFirstBatch(packages.slice(0, firstBatchCount));
    setSecondBatch(packages.slice(firstBatchCount));
    setHasPromo(checkPromotions(packages))
    salesContext.setAdditionalServices(null)
  }, []);

  useEffect(() => {

    let packages = [...salesContext.providerPackages];

    if (salesContext.filters.onPromotion) {
      packages = filterByDiscount(packages);
    }

    if (salesContext.filters.selectedSpeeds?.length) {
      packages = filterBySpeeds(packages, salesContext.filters.selectedSpeeds);
    }

    packages = orderBy(packages, salesContext.sortOrder);

    setFirstBatch(packages.slice(0, firstBatchCount));
    setSecondBatch(packages.slice(firstBatchCount));
    setTopPicks(salesContext.topPicks);
    setHasPromo(checkPromotions(packages))
  }, [
    salesContext.providerPackages,
    salesContext.sortOrder,
    salesContext.filters.onPromotion,
    salesContext.filters.selectedSpeeds,
    salesContext.topPicks,
  ]);

  useEffect(() => {
    let packages = [...salesContext.providerPackages];

    if (packages?.length > 0 && salesContext.selectedContractTerm) {
      let uniqueSpeeds = getUniqueSpeedsArray(packages);

      hasRedirected 
      ? tagOnChooseFibrePlan(appProactiveSalesFlag, miniAppProactiveSalesFlag, uniqueSpeeds, true)
      : tagOnChooseFibrePlan(appProactiveSalesFlag, miniAppProactiveSalesFlag, uniqueSpeeds)
      
      tagContractTermFilterClick(salesContext.selectedContractTerm);
    }
  }, [salesContext.providerPackages, salesContext.selectedContractTerm]);

  const changeAddress = () => {

    sessionStorage.clear()

    window.location.href = '/vodacom/fibre/sales/leads';
  };

  const switchToBusiness = () => {

    tagOnSwitchToBusinessClick()

    window.location.href = `https://www${getEnv()}.vodacombusiness.co.za/business/fibre/sales/lead`;
  };

  const navigaToPlanDetails = async (plan, topPicks = false) => {

    if (plan.subscriptionType === 'Prepaid') {

      tagOnPrepaidCardClick()

      const url = `${PrepaidFibreUrls[window.location.hostname]}?address=${salesContext.installationAddress?.formattedAddress}&lat=${salesContext.installationAddress?.latitude}&lng=${salesContext.installationAddress?.longitude}`;

      window.location.replace(url);

      return
    }

    if (topPicks) {
      tagOnTopPickClick(plan?.download, plan?.upload, plan?.fromPrice?.value)

      salesContext.setSelectedContractTerm('Month to Month')
    }

    await getPlanDetails(plan)

    props.history.push('/cloud/fibre/sales/planDetails')
  };

  const HandleContractLenghtDropDownClick = () => {

    setHasSelectedContractLength(true)
    setDrawerOpen(true)
  };

  const HandleMainFilterClick = () => {

    setHasSelectedContractLength(false)
    setDrawerOpen(true)
  };

  const navigateToHomePage = () => {

    window.location.href = '/cloud/fibre/sales/leads';
  };

  return (
    <div className='deal-grid-main-container'>

      <div className='deal-grid-top-picks-container'>

        <div className='deal-grid-breadcrumbs-container'>
          {isMobile ? <div className='deal-grid-back-container' onClick={navigateToHomePage}><ChevronLeft /> <div style={{fontSize: '16px'}}>Back to Fibre</div></div> : <GridBreadcrumbs currentPath={'CHOOSEPLAN'} isFibreAvailable={salesContext.providerPackages?.length > 0} />}
          <div className='deal-grid-switch-to-business' onClick={switchToBusiness}>{isMobile ? 'Business' : 'Switch to Business'}<BlueRightArrow /></div>
        </div>

        <div className='deal-grid-address-container'>
          <div className='deal-grid-address'>{salesContext.installationAddress?.formattedAddress}</div>
          <div className='deal-grid-address-icon' onClick={changeAddress}><PencilIcon />{!isMobile && 'Change address'}</div>
        </div>

        {salesContext?.providerPackages?.length > 0 &&
          <>
            {topPicks.length > 0 &&
              <div className='deal-grid-top-picks-heading'>
                Top picks for you
              </div>
            }

            <div className='deal-grid-top-picks'>
              {topPicks?.map((deal, index) => (
                !isMobileView() ? (
                  <Card
                    key={`first-${index}`}
                    selectPackage={() => navigaToPlanDetails(deal, true)}
                    price={deal?.fromPrice?.value?.toString()}
                    originalPrice={deal?.originalPrice?.toString()}
                    downloadSpeed={deal?.download}
                    uploadSpeed={deal?.upload}
                    duration={deal?.contractTerm}
                    promotion={deal?.onDiscount}
                    cardKey={deal?.cardKey}
                    isTopPick={true}
                  />
                ) : (
                  <TopPicks
                    key={index}
                    selectPackage={() => navigaToPlanDetails(deal, true)}
                    price={deal?.fromPrice?.value?.toString()}
                    originalPrice={deal?.originalPrice?.toString()}
                    downloadSpeed={deal?.download}
                    uploadSpeed={deal?.upload}
                    duration={deal?.contractTerm}
                    promotion={deal?.onDiscount}
                    cardKey={deal.cardKey}
                  />
                )
              ))}
            </div>
          </>}

      </div>

      <Curve
        upperBackground='white'
        upperMain='#08081B'
        lowerBackground='#08081B'
        lowerMain='#FFFFFF'
      />

      {salesContext.providerPackages?.length > 0

        ? <div className='card-grid-container'>

          <div className='card-grid-container-heading'>All plans for your address</div>

          <div className='card-grid-details'>



            <div className='card-grid-text-container'>


              <div className='card-grid-text'>

                <div className='card-grid-filters-text'>
                  Filters
                </div>

                <div className='filter-text-main'>
                  <div className='card-results'>{`${firstBatch?.length + secondBatch?.length} of ${salesContext.providerPackages?.length} results`}</div>


                  <div className='card-filter-dropdown'>
                    <FilterDropDown
                      selectedValue={salesContext.sortOrder}
                      options={sortOptions}
                      updateSelectedOption={updateSortSelection}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='card-grid-details-mobile'>

            <div className='card-grid-text-mobile'>
              <div className='card-filter-count-container' onClick={HandleMainFilterClick}>

                <div className='card-filter-count-text'>Filters</div>
                <div className={salesContext?.filters?.selectedSpeeds?.length > 0 ? 'card-filter-count-special' : 'card-filter-count'}>{salesContext?.filters?.selectedSpeeds?.length || 0}</div>
              </div>

              <div className='card-filter-count-container' onClick={HandleContractLenghtDropDownClick}>
                <div className='card-filter-count-text'>{salesContext.selectedContractTerm}</div>
                <div><ArrowIcon direction={'icon-chevron-down'} /></div>
              </div>
            </div>

            <div className='card-grid-text-mobile'>
              <div className='card-results-mobile'>{`${salesContext.providerPackages?.length} of ${salesContext.providerPackages?.length} results`}</div>
              <FilterDropDown
                selectedValue={salesContext.sortOrder}
                options={sortOptions}
                updateSelectedOption={updateSortSelection}
              />
            </div>
          </div>


          <div className='card-grid-wrapper'>
            <div className='card-grid-filters'>

              <hr style={{ width: '90%', margin: '0px', borderWidth: '0.6px', borderColor: 'rgba(8, 8, 27, 0.15)' }} />


              <Pill label='Contract length'
                content={
                  <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '6px' }}>
                    {contractTerms?.map((term, index) => (

                      <Checkbox
                        key={index}
                        label={term === 'Month to Month' ? 'Month-to-month' : `${term.toLowerCase()} contract`}
                        checked={salesContext.selectedContractTerm === term}
                        onChange={() => handleTermCheckboxChange(term)}
                        value={!!salesContext.selectedContractTerm}
                        padding={'0 6px 0 0'}
                        isRadio={true}
                      />
                    ))
                    }
                  </div>
                }
                defaultOpen={!!salesContext.selectedContractTerm} />

              <hr style={{ width: '90%', margin: '0px', borderWidth: '0.6px', borderColor: 'rgba(8, 8, 27, 0.15)' }} />

              <Pill label='Download speed'
                content={
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {salesContext.filters?.downloadSpeed?.map((speed, index) => (
                      <Checkbox
                        key={index}
                        label={speed}
                        checked={salesContext.filters?.selectedSpeeds?.includes(speed)}
                        onChange={() => handleSpeedCheckboxChange(speed)}
                        automatioIdAttr={`Speed_${index}`}
                        value={salesContext.filters?.selectedSpeeds?.includes(speed)}
                      />
                    ))}
                  </div>
                } />

              <hr style={{ width: '90%', margin: '0px', borderWidth: '0.6px', borderColor: 'rgba(8, 8, 27, 0.15)' }} />

              {hasPromo &&
                <Pill label='Promotions'
                  content={
                    <Checkbox
                      label="Show promotions only"
                      checked={salesContext?.filters?.onPromotion}
                      onChange={handlePromotionsCheckboxChange}
                      value={!!salesContext?.filters?.onPromotion}
                    />
                  }
                />
              }
            </div>

            <div className='card-wrapper'>

              {salesContext?.filters?.selectedSpeeds?.length > 0 &&
                <div className='card-selected-filters'>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    {salesContext.filters.selectedSpeeds?.map((speed, index) => (

                      <div
                        key={index} className="selected-filters-bubble"
                        onClick={() => handleSpeedCheckboxChange(speed)}>
                        <div>{speed}</div>
                        <div>x</div>
                      </div>
                    ))
                    }
                  </div>
                  <div
                    className='card-selected-filters-text'
                    onClick={clearFilters}>
                    Clear all
                  </div>

                </div>
              }

              <div className='card-grid'>
                {firstBatch.map((deal, index) => (
                  <Card
                    key={`first-${index}`}
                    selectPackage={() => navigaToPlanDetails(deal)}
                    price={deal?.fromPrice?.value?.toString()}
                    originalPrice={deal?.originalPrice?.toString()}
                    downloadSpeed={deal?.download}
                    uploadSpeed={deal?.upload}
                    duration={deal?.contractTerm}
                    promotion={deal?.onDiscount}
                    subscriptionType={deal.subscriptionType}
                  />
                ))}
              </div>

              <div className='grid-help-me-choose'>
                <NewHelpMeChoosePlan/>
              </div>

              <div className='card-grid'>
                {secondBatch?.map((deal, index) => (
                  <Card
                    key={index}
                    selectPackage={() => navigaToPlanDetails(deal)}
                    price={deal?.fromPrice?.value?.toString()}
                    originalPrice={deal?.originalPrice?.toString()}
                    downloadSpeed={deal?.download}
                    uploadSpeed={deal?.upload}
                    promotion={deal?.onDiscount}
                    duration={deal?.contractTerm}
                    subscriptionType={deal.subscriptionType}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        : <div className='deals-not-found'> <NoDealsFound /></div>
      }

      <Curve
        upperBackground='#141827'
        upperMain='#FFFFFF'
        lowerBackground=' #FFFFFF '
        lowerMain='#141827'
        upperCurveDirection={'left'}
        lowerCurveDirection={'left'}
      />

      <WhyChooseVodacomFibre isForm={false} />

      {/* <Curve
        upperBackground='#08081B'
        upperMain='#141827'
        lowerBackground=' #141827'
        lowerMain='#08081B'
        upperCurveDirection={'left'}
        lowerCurveDirection={'left'}
      /> */}

      <SideDrawer
        isOpen={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        defaultFilter={hasSelectedContractLength}
      />
    </div>
  );
};

export default DealGrid;
